var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadReceipts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "87px",
    height: "63px",
    viewBox: "0 0 87 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 13,
    cy: 13,
    r: 13
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-Upgrade-&-Payment-\\uD83D\\uDCB3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Upgrade-3",
    transform: "translate(-143.000000, -123.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Upgrade/Read-Receipts",
    transform: "translate(113.000000, 81.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(31.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy",
    fill: "#CCCCCC",
    fillRule: "nonzero",
    stroke: "#CCCCCC",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mail"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0043936,0 L8.06146812,0 C3.61134168,0.00506490293 0.00506448879,3.611637 0,8.06212733 L0,47.8245393 C0.00506448879,52.2750297 3.61134168,55.8816018 8.06146812,55.8866667 L69.0042324,55.8866667 C73.4543588,55.8816018 77.060636,52.2750297 77.0657005,47.8245393 L77.0657005,8.06212733 C77.0608135,3.61162629 73.4545306,0.00497640359 69.0043936,0 Z M54.6711033,27.9323688 L73.8412745,12.8855369 L73.8412745,46.5429836 L54.6711033,27.9323688 Z M8.06146812,3.22485093 L69.0042324,3.22485093 C71.6743156,3.22787214 73.8380923,5.39182577 73.8411132,8.06212733 L73.8411132,8.78610637 L42.8189716,33.1366333 C40.4850918,34.9588021 37.2099873,34.9561417 34.8790704,33.1301836 L3.22458725,8.77997915 L3.22458725,8.06212733 C3.22760821,5.39182577 5.3913849,3.22787214 8.06146812,3.22485093 Z M22.9651879,28.0336292 L3.22458725,46.6079643 L3.22458725,12.8484511 L22.9651879,28.0336292 Z M69.0043936,52.6618157 L8.06146812,52.6618157 C6.3824471,52.6608385 4.82398598,51.7893277 3.94399266,50.3592722 L25.554209,30.026587 L32.9033658,35.6797507 C36.4005961,38.4117068 41.3088489,38.4104434 44.8046724,35.6766871 L52.1114259,29.9427409 L73.1300917,50.3463728 C72.2516178,51.7837713 70.6888794,52.6608184 69.0043936,52.6618157 Z",
    id: "Shape"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icon/General/Tick",
    transform: "translate(58.000000, 34.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Colors/Maroon",
    mask: "url(#mask-2)",
    fill: "#710D0D"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.000000, -2.000000)",
    id: "Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 30,
    height: 30
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M12.9075071,16.360854 L19.3484781,10.4033015 C19.9634631,9.83447343 20.9231332,9.87189098 21.4919613,10.486876 C22.0607894,11.1018609 22.0233718,12.061531 21.4083869,12.6303591 L13.8767683,19.596702 C13.2707922,20.1571974 12.3278608,20.1302319 11.7549064,19.5360219 L8.42491723,16.0824963 C7.84344493,15.4794524 7.86093212,14.5192124 8.46397597,13.9377401 C9.06701982,13.3562678 10.0272599,13.373755 10.6087322,13.9767988 L12.9075071,16.360854 Z",
    id: "Tick",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadReceipts);
export default __webpack_public_path__ + "static/media/read_receipts.4f550e8f07bcc3076242c9b03793861b.svg";
export { ForwardRef as ReactComponent };